var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0.75C8.89922 0.75 11.25 3.10078 11.25 6C11.25 8.89922 8.89922 11.25 6 11.25C3.10078 11.25 0.75 8.89922 0.75 6C0.75 3.10078 3.10078 0.75 6 0.75ZM3.75 6.28125C3.75 6.33281 3.79219 6.375 3.84375 6.375H5.625V8.15625C5.625 8.20781 5.66719 8.25 5.71875 8.25H6.28125C6.33281 8.25 6.375 8.20781 6.375 8.15625V6.375H8.15625C8.20781 6.375 8.25 6.33281 8.25 6.28125V5.71875C8.25 5.66719 8.20781 5.625 8.15625 5.625H6.375V3.84375C6.375 3.79219 6.33281 3.75 6.28125 3.75H5.71875C5.66719 3.75 5.625 3.79219 5.625 3.84375V5.625H3.84375C3.79219 5.625 3.75 5.66719 3.75 5.71875V6.28125Z",
    fill: "#696969"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNew);
export default __webpack_public_path__ + "static/media/new.b256a5e9198fb86583212652db3854fa.svg";
export { ForwardRef as ReactComponent };